import React from "react";
import { StyledBadge } from "./styles";
import { BadgeProps } from "./types";

/**
 * Componente Badge
 *
 * Um rótulo estilizado para exibir informações em destaque.
 *
 * @param {string} label - Texto exibido dentro do Badge.
 * @param {keyof typeof theme.colors.font} [backgroundColor='yellow'] - Cor de fundo do Badge.
 */
export const Badge: React.FC<BadgeProps> = ({ label, backgroundColor }) => {
  return <StyledBadge backgroundColor={backgroundColor}>{label}</StyledBadge>;
};
